
import { mapState } from 'vuex';

import serviceOrder from "../../services/orders/OrderService.js";
import dispensation from "../../services/dispenzation/AllDispenzation.js"
import pendingReasonsService from './../../services/pending-reasons/PendingReasonsService.js'
import serviceDocument from "../../services/patient/DocumentService.js";
import i18n from "../../i18n/index";
import { VMoney } from 'v-money'
import dayjs from "dayjs";
import { StorageService } from "../../services/StorageService.js";
import kardex from "../../services/kardex/kardex-medicine.js";
import QrScanner from './../../components/QrScanner.vue';


export default {
    props: ["status", "enabledColumns","item"],
    components: {
        VMoney,
        QrScanner,
    },
    props: {
        isSpoiled: {
            type: Boolean,
            default: () => {}
        },
        
    },
    data() {
        return {
            qrResult: '',
            scanQR: false,
            result: '',
            error: '',
            facingMode: 'environment',
            loadingsave: false,
            imagenn: false,
            itemString:null,
            encabezados: [
                { text: 'ESTADO', value: 'estado' },
                { text: 'FECHA', value: 'fecha' },
                { text: 'MOTIVO', value: 'motivo' },
            ],
            campos: [],
            testFile: null,
            dialog: false,
            cleanmodal:false,
            observationDispenzer:"",
            authorizationsLoaded: false,
            menuDelivery: false,
            allMedicinesValid:false,
            pendingReasonItems: [],
            menuPreviewDelivered: false,
            date_previewDelivered: "",
            datePreviewDelivery: "",
            slidingScaleFee: '',
            rules: {
                required: value => !!value || "El campo es requerido"
            },
            checked: "",
            validFormPatient: false,
            validFormOrderDetailList: false,
            validFormNotes: false,
            validFormOrder: false,
            selectOrderCode: "",
            searchorder:false,
            paginationn: {},
            isFeatured: false,
            isApplicable: false,
            isWatched: false,
            orderTable: {
                searchItems: 0,
                searchTerm: ""
            },
            patient: {
                id: "",
                documentType: "",
                document: "",
                fullname: "",
                address: "",
                mobilePhone: null,
                phone: null,
                idIncomeGroup: "",
                isPac: false,
                isPolicy: false
            },
            typeCancelAuthorization: "",
            order: {
                id: "",
                status: "",
                number: "",
                deliveryAddress: "",
                orderType: {},
                deliveryDate: "",
                notApplyShippingFee: false
            },
            numbreThree: "",
            reloadsearch:false,
            numberTwo: "",
            numberOne: "",
            nameNomenclature: "",
            nomenclature: [
                "Anillo",
                "Autopista",
                "Avenida",
                "Avenida Calle",
                "Avenida Carrera",
                "Calle",
                "Carrera",
                "Circular",
                "Diagonal",
                "Transversal",
                "Zona"
            ],
            observation: "",
            note: "",
            itemTypeOrder: [{
                    id: "EXCLUSIVE",
                    name: "Exclusivo"
                },
                {
                    id: "INTEGRATED",
                    name: "Integrado"
                }
            ],
            error: false,
            orderDetail: [],
            // Location selects
            states: [],
            cities: [],
            branches: [],
            scheduleRanges: [],
            location: {
                state: "",
                city: "",
                branch: "",
                scheduleRange: ""
            },
            listMedicine: [],
            patientListData: [],
            documentTypeItems: [],
            createReminder: false,
            addM: false,
            time: 2000,
            snackbar: false,
            showGrid: false,
            showGridAppointment: false,
            dataMedicines: [],
            cancelReason: "",
            headers: [{
                    sortable: true,
                    text: "Orden",
                    value: "orderCode",
                    align: "left"
                },
                {
                    sortable: false,
                    text: i18n.t("headers.provider"),
                    value: "providerId",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Valor cuota moderadora",
                    value: "scaleFee",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Número de entrega",
                    value: "deliveryNumber",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Acciones",
                    value: "actions",
                    align: "left",
                    name: "actions"
                }
            ],
            typeCancelOrder: [],
            typeCancelAuthorization: [],
            daysOfWeek: [],
            selectedScheduleRange: "",
            showOrderNumber: false,
            isNewOrder: true,
            money: {
                decimal: ".",
                thousands: ",",
                precision: 0,
                masked: false
            },
            attachments: [],
            disableSaveButton: false,
            SCHEDULED_ORDER_STATUS: "SCHEDULED",
            incomeGroupItems: [],
            lastCitySelected: "",
            dontApplyShippingFee: false,
            user: "",
            searchButtonLoading: false,
            fechaAllowed: "",
            maxDate: "",
            nameDissabled: false,
            searchIdentification: "",
            availableDates: null,
            searchIdentificationType: "",
            holidays: [],
            cellphoneEnable: false,
            phoneEnable: false,
            disableShippingFee: false,
            typePropertys: ['-Tipo de inmueble-', 'Casa', 'Edificio', 'Hotel', 'Oficina', 'Urbanización'],
            typeProperty: "",
            blockOrInteriors: ['-Bloque o interior-', 'Manzana', 'Zona', 'Bloque', 'Habitación', 'Apartamento', 'Piso'],
            blockOrInterior: "",
            observationOne: "",
            observationTwo: "",
            isPrioritizedPatient: false,
            validMedicine: [],
            validateBrach: true,
            maxDatePreviewDelivery: "",
            disableBranches: true,
            attachmentURL: '',
            showDownloadAttachment: false,
            isUnifiedPharmacy: false,
            forceShippingFee: [],
            addressFromSura: '',
            deliveredCount:0,
            orderFromSura: false,
            // isPAC: false,
            //hasPolicy: false,
            // isSpoiled: false,
            cancelReasonSpecialMedicine: '',
            URLAttachments: [],
            isMinDateLoaded: false,
            imagenessuportt: [],
            imagenmodalsupor: [],
            rowpage: 1,
            rowsPerPageItems: [5, 10, 15, 20],
            array: [],
            isProviderPresent: false,
            totalcampos: 0,
            errordispenzation: false,
            documentTypeAuto:null,
            documentAuto:"",
            birthdate:null,
            searchUser:[],
            dataAuto:false,
            Usercode:"QAT1",
            Username:"Sucursal QA Test",
            orderDetailsMedicinesPatient:[],

        }
    },
    directives: { money: VMoney },
    created() {
        this.itemString = this.$route.query.item;
        if(this.$route.query.item){
            this.patientCode=this.itemString.prescriptionOrderId
            console.log('this.patientCode', this.patientCode);
            this.observationDispenzer=this.itemString.medicines_list[0].observations
            // this.searchAuthorizations(this.itemString);
            this.getCancelReasons()
            this.dataAuto=true;
            this.searchResult = this.itemString;
            this.searchUser.dui= this.itemString.document_id
            this.authorizationsLoaded=true;
            this.disableSaveButton=true;
        }
        
       
        console.log('item:', this.itemString);
        this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
        // this.getProviders();
        this.getDocuments();
        this.order.orderType = this.itemTypeOrder[0];
        // this.getCancelReasons();
        this.isProviderPresent = this.providerId !== null && this.providerId !== this.integratedProvider
        // this.updateSlidingScaleFee();
        this.getPendingReason()
         
       
    },
    mounted() {
        
        //this.getHolidays();
        // this.getUserName();
    },
    watch: {
        pendingmedicine:{
            handler() {
                console.log("esteee es uno")
                    // this.listhistory();
            },
            deep: true
        },
        
        paginationn: {
            handler() {
                console.log("esteee es uno")
                    // this.listhistory();
            },
            deep: true
        }
    },
    methods: {
        handleQrDetected(content) {
            this.patientCode = content;
            this.searchAuthorizations(content);
          },
        onDecode(decodedString) {
            this.result = decodedString;
            this.scanQR = false;
          },
          onInit(promise) {
            promise.catch(err => {
              this.error = err.message;
            });
          },
          onError(err) {
            this.error = `[${err.name}]: ${err.message}`;
          },
          toggleCamera() {
            this.facingMode = this.facingMode === 'environment' ? 'user' : 'environment';
          },
      
        clean(){
            this.cleanmodal=true;
          
        },
        closedModal(){
            if(this.$route.query.item){
                this.$router.push("/report-dis-site");
            }else{
                this.cleanmodal=false;
                window.location.reload(); 
            }
             
           
        },
       
        getPendingReason() {
            pendingReasonsService.getPendings().then(response => {
               // console.log("response.data",response.data)
                this.pendingReasonItems = response.data.filter( item => item.active === true);
            })
        },
        getPendingReasonName(id) {
            let pendingReasonItem = this.pendingReasonItems.find(
                item => item.id === id
            )
            return pendingReasonItem ? pendingReasonItem.name : ''
        },
        validationAfterChangeQuantity(medicine) {
          
            this.updateEnablePendingReason(medicine)
        },
        updateEnablePendingReason(medicine) {
            console.log("medicine",medicine);
            medicine.deliveredCount =parseInt(medicine.deliveredCount) > -1 ? parseInt(medicine.deliveredCount) : 0

            medicine.deliveredCount=parseInt(medicine.deliveredCount)> parseInt(medicine.available_quantity) ? parseInt(medicine.available_quantity):parseInt(medicine.deliveredCount)
            medicine.enablePendingReason =parseInt(medicine.available_quantity) -parseInt(medicine.deliveredCount) !== 0

            if (parseInt(medicine.deliveredCount) === parseInt(medicine.available_quantity)) {
                medicine.pendingReason = 0
            }

            // this.updateSlidingScaleFee()
        },
       

        maxNumberOfField(medicine) {
            // this.orderDetails.forEach(order => {

                if ( parseInt(medicine.deliveredCount) > parseInt(medicine.available_quantity)) {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'El numero de la cantidad entregada no debe ser superior al de la cantidad.'
                    })
                }
            // });
        },
        onlyNumber(e) {
            const key = e.key;
            if (key === '.' || key === '-')
                return e.preventDefault();
        },
        getDocumentTypeName(documentTypeId) {
            const documentType = this.documentTypeItems.find(type => type.id === documentTypeId);
            return documentType ? documentType.name : '';
          },
        
       
        clickimagen(imagen) {
            this.imagenn = true;
            this.imagenmodalsupor = imagen
            const arrFront = new Uint8Array(imagen.data.data);
            let typeString = "";
            console.log("x1 user", imagen);
            switch (imagen.fileType) {
                case "jpg":
                    typeString = "image/jpeg";
                    break;
                case "jpeg":
                    typeString = "image/jpeg";
                    break;
                case "png":
                    typeString = "image/png";
                    break;
                case "pdf":
                    typeString = "application/pdf";
                    break;
                default:
                    break;
            }
            const blobFront = new Blob([arrFront], { type: typeString });
            let fileURLFront = window.URL.createObjectURL(blobFront);
            this.imagenmodalsupor = {
                fileName: imagen.fileName,
                imageFront: fileURLFront,
            };
        },
        closed() {
            this.imagenn = false;
        },
        async download(url) {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = () => {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(xhr.response);
                const link = document.createElement("a");
                link.href = imageUrl;
                link.setAttribute("download", this.imagenmodalsupor.fileName);
                link.setAttribute("target", "new");
                document.body.appendChild(link);
                link.click();
            };
            xhr.open("GET", url);
            xhr.send();
            console.log('downloading', url);
        },

      
        async getUserId() {
            let userId = await StorageService.getUserData().id;
            if (!userId || typeof userId === 'string') {
                if (this.userInfo) {
                    userId = this.userInfo.id
                }
                userId = 0
            }
            return userId
        },

        async getProviderIds(orderDetails) {
            let providerIds = []
            orderDetails.map(orderDetail => {
                providerIds.push(orderDetail.providerId)
            })
            return providerIds;
        },

        getUserName() {
            const user = StorageService.getUserData();
            this.user = user.name;
        },
        contains(arr, id) {
            return arr.some(e => e.id === id);
        },
        getDefaultProviderId() {
            const hasOrderDetails = this.orderDetail.length > 0;
            let providerId = -1;

            if (
                hasOrderDetails &&
                this.order.orderType &&
                this.order.orderType !== ""
            ) {
                if (this.order.orderType === this.itemTypeOrder[0].id) {
                    // let detailStatus = this.orderDetail.find(od => od.medicines.find(m => m.check === true))
                    let medicine = this.dataMedicines.find(medicine => medicine.check === true)
                    if (medicine === undefined) {
                        providerId = this.dataMedicines[0].providerId;
                    } else {
                        providerId = medicine.providerId
                    }
                } else {
                    providerId = StorageService.getIntegratedProvider();
                }
            }

            return providerId;
        },
        getDocuments() {
            serviceDocument.getDocuments().then(response => {
                this.documentTypeItems = response.data;
            });
        },
       
        async getStates(order) {
            let providersAux = []
            this.dataMedicines.forEach(medicine => {
                if (medicine.check === true) {
                    if (!providersAux.includes(medicine.providerName)) {
                        providersAux.push(medicine.providerName);
                    }
                }
            })
            const moreThanOneProvider = providersAux.length > 1;

            let type = !moreThanOneProvider ?
                this.itemTypeOrder[0].id :
                this.itemTypeOrder[1].id

            const providerId = this.getDefaultProviderId();

            let response = await locationService.getStatesByProvider(1, type, providerId)
            this.states = response.data;
            if (!this.contains(this.states, this.location.state)) {
                if (!this.isNewOrder && order) {
                    this.states.push({
                        id: order.idCity.idState.id,
                        name: order.idCity.idState.name
                    })
                } else {
                    this.location.state = "";
                }
            }
            if (!this.contains(this.cities, this.location.city)) {
                this.location.city = "";
            }
            if (!this.contains(this.branches, this.location.branch)) {
                this.location.branch = "";
            }
            if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
                this.location.scheduleRange = "";
            }
            if (this.states.length === 0) {
                this.showNoCoverageForAnyCity("warning");
                console.log("Entro citis 3");
            }
        },
       
        async saveScheduling() {
            this.loadingsave = true;
            this.disableSaveButton = true;
            if (!this.searchResult) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-no-patients"),
                    duration: 5000
                });
                this.errordispenzation = true;
                this.disableSaveButton = false;
                this.loadingsave = false;
                return;
            }
            if(!this.searchUser){
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-no-patients-authorizations"),
                    duration: 5000
                });
                this.errordispenzation = true;
                this.disableSaveButton = false;
                this.loadingsave = false;
                return;
            }
            this.searchResult.medicines_list.forEach(medicine => {
                // Verifica si el elemento está seleccionado
                if (medicine.check && medicine.available_quantity - medicine.deliveredCount !== 0) {
                  // Valida si medicine.pendingReason está vacío
                  if (!medicine.pendingReason) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Por favor seleccione un motivo pendiente para todas las medicinas.",
                        duration: 5000
                    });
                    this.errordispenzation = true;
                    this.disableSaveButton = false;
                    this.loadingsave = false;
                    return;
                  }
                }
              });
              console.log("this.searchUser.dui",this.searchUser.dui);
            if(this.searchUser.dui===undefined||this.searchUser.dui===null){
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Debe tener asociado un reclamante.",
                    duration: 5000
                });
                this.errordispenzation = true;
                this.disableSaveButton = false;
                this.loadingsave = false;
                return; 
            }else{
                if( this.errordispenzation === true){
                    this.errordispenzation = false;
                }else{
                    let userId = await this.getUserId();
                    //let providerIds = await this.getProviderIds(this.orderDetail);
                    const providerId = this.getDefaultProviderId();
        
                    
                    const userString = localStorage.getItem('user');
                   
                    const user = JSON.parse(userString);
              
                        if (user.idBranch === "") {
                            this.disableSaveButton = false;
                            this.loadingsave = false;
                          this.$notify({
                            group: "app",
                            type: "error",
                            text: "No se puede dispensar, el usuario no se encuentra asociado a una sede",
                            duration: 5000
                          });
                         
                        } else {
                        let formData = { ...this.searchResult };
                        // formData.medicines_list = formData.medicines_list.map(({ pendingmedicine, check, ...rest }) => rest);
                        formData.document_id = this.searchUser.dui;
                        formData.document_type = 1;
                        formData.full_name = this.searchUser.first_last_name+" "+ this.searchUser.second_last_name +" "+ this.searchUser.first_name+" "+ this.searchUser.second_name
                        formData.medicines_list = formData.medicines_list.filter(medicine => medicine.status != 1).map(medicine => {
                            return {
                              ...medicine,
                              observations: medicine.observations || this.observationDispenzer,
                              "cs_updated_user_code": this.Usercode,
                              "cs_updated_user_name": this.Username,
                              quantity:medicine.deliveredCount,
                            };
                          });
                        console.log("formData--------------------->",formData)
                        try {
                              let responseScheduling = await dispensation.saveDispensePrescription(formData)
                            this.$notify({
                                group: "app",
                                type: "success",
                                text: "Dispensado correctamente",
                                duration: 5000
                            });
                            this.disableSaveButton = false;
                            this.loadingsave = false;
                            this.authorizationsLoaded =false;
                            this.searchResult = [];
                            this.searchUser= [];
                            this.dataAuto=false;
                            this.patientCode="";
                            
                        } catch (error) {
                            this.loadingsave = false;
                            console.log("error",error)
                            if (error.error === 'Order already scheduled') {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: "Alguna de las autorizaciones ya ha sido agenda, vuelva a consultar de nuevo las autorizaciones del paciente",
                                    duration: 10000
                                });
                            } else {
                                this.disableSaveButton = false;
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: "Ha ocurrido un error al dispenzar el pedido"
                                });
                            }
                        }
                    }
                  
                    
                }
            }
            
           
        },

      

        validateOrderDetail() {
            let count = 0
            for (const medicine of this.searchResult.medicines_list) {
                if (medicine.check === false) {
                    count++
                }
            }
            if (count === this.searchResult.medicines_list.length) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'El pedido debe tener al menos una autorización asociada.'
                });
                this.disableSaveButton = true
                return;
            }
            this.disableSaveButton = false
            // if (this.isNewOrder) {
            //     this.updateOrderType();
            // }
        },
      
       
        disabled(patient) {
            this.disableSaveButton = false;
            if (this.validateNumberCellphone(patient)) {
                // this.disableSaveButton = true;
            } else if (this.validateNumberphone(patient)) {
                // this.disableSaveButton = true;
            }
        },
       
        changeCancelReason(medicine) {
            medicine.pendingReason=null;
            medicine.deliveredCount=0;
            if (medicine.typeCancelAuthorization === undefined) {
                this.searchResult.medicines_list.forEach((med) => {
                    if (med.index === medicine.index) {
                        med.check = true
                        med.typeCancelAuthorization = null
                        med.datePreviewDelivery = ''
                    }
                });
                this.validateOrderDetail();
                return
            }
            let cancelReason = medicine.typeCancelAuthorization
            this.searchResult.medicines_list.forEach((med) => {
                if (med.index === medicine.index) {
                    med.check = false
                    if (cancelReason === 'Previamente entregado') {
                        med.datePreviewDelivery = medicine.datePreviewDelivery
                    } else {
                        med.datePreviewDelivery = ''
                    }
                    med.typeCancelAuthorization = cancelReason
                }
            })
            this.validateOrderDetail();
        },
        
        getCancelReasons() {

            serviceOrder.getTypeAuthorizationOrder().then(result => {
                // this.listhistory();
                console.log("result.data",result.data)
                this.typeCancelAuthorization = result.data.filter( item => item.active === true)
                if(this.typeCancelAuthorization.code==='No data available'){
                    this.typeCancelAuthorization='No data available';
                }
                
            });
            // serviceOrder.getTypePedidoOrder().then(result => this.typeCancelOrder = result.data);
        },
        async searchUserAutho() {
            this.searchUser = [];
            let formattedBirthdate = this.birthdate;
            if (!/^\d{4}-\d{2}-\d{2}$/.test(this.birthdate)) {
                const date = new Date(this.birthdate);
                formattedBirthdate = date.toISOString().split('T')[0];
              }
            let response = await dispensation.getConsultDocument(this.documentAuto,formattedBirthdate,this.documentTypeAuto);
            console.log("response",response)
            if (response.data && response.data.dui === this.documentAuto) {
                this.dataAuto=true;
                this.searchUser = response.data;
                this.documentAuto="";
                this.birthdate="";
                this.documentTypeAuto=null;
            } else {
                this.documentAuto="";
                this.birthdate="";
                this.documentTypeAuto=null;
                this.dataAuto=false;
                this.searchUser=[];
              this.$notify({
                group: "app",
                type: "error",
                text: "No se encontró ningún resultado."
            });
            return;
            }
          
        },
        async searchAuthorizations() {
            if(this.searchResult === ""){
                        const userConfirmed = window.confirm('¿Seguro de que desea cancelar la búsqueda?');
                        if (userConfirmed) {
                            this.authorizationsLoaded =false;
                            this.patientCode = '';
                          } else {
                            return
                          }
                       
                    }
            this.searchButtonLoading = true;
            this.searchResult = [];
            
            let response = await dispensation.getPrescriptionDetail(this.patientCode);
            this.searchButtonLoading = false;
            
            // Verifica si response.data no es nulo y contiene un número de prescripción válido
            if (response.data && response.data.prescription_number === parseInt(this.patientCode)) {
                if (Array.isArray(response.data.medicines_list)) {
                    response.data.medicines_list.forEach(medicine => {
                        
                        medicine.check = medicine.status !== '1';
                      medicine.deliveredCount= medicine.available_quantity;
                      if (medicine.status === '1') {
                        this.allMedicinesValid = true;
                    }
                    });
                  }
              this.orderDetailsMedicinesPatient = response.data; 
              this.searchResult = this.orderDetailsMedicinesPatient;
              this.authorizationsLoaded = true;
              this.getCancelReasons();
            } else {
              this.authorizationsLoaded = false;
              this.$notify({
                group: "app",
                type: "error",
                text: "No se encontró recetas asociadas."
              });
            }
      
            this.searchButtonLoading = false;
        },
      
           
       


        async searchAuthorizationsCompensar() {
            let user = JSON.parse(localStorage.getItem("user"));
            await serviceOrder
               
        },
       
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isCityDisabled() {
            return this.location.state === "";
        },
        isBranchDisabled() {
            return this.location.city === "";
        },
        isScheduleRangeDisabled() {
            return this.location.branch === "";
        },
        notes: {
            get() {

                let ordersForFee = this.dataMedicines
                    .filter(m => m.check)
                    .map(item => {
                        return { code: item.orderCode, fee: item.scaleFee }
                    })

                ordersForFee = Array.from(new Set(ordersForFee.map(a => a.code)))
                    .map(code => {
                        return ordersForFee.find(a => a.code === code)
                    })

                let slidingScaleFeeTotal = ordersForFee
                    .map(item => item.fee)
                    .reduce((a, b) => a + +b, 0);

                let scheduleRange = {};

                if (this.location && this.location.scheduleRange) {
                    scheduleRange = this.scheduleRanges.find(
                        scheduleRange => scheduleRange.id === this.location.scheduleRange
                    );
                }

                let shippingFee =
                    scheduleRange && scheduleRange.shippingFee ?
                    scheduleRange.shippingFee :
                    0;

                if (this.order.notApplyShippingFee) {
                    shippingFee = 0;
                }
                let recoveryFeeText = "";
                let ordersForRecoveryFee = this.dataMedicines
                    .filter(m => m.check && m.paymentType === 'CUOTA DE RECUPERACION')

                ordersForRecoveryFee = Array.from(new Set(ordersForRecoveryFee.map(a => a.orderCode)))

                if (ordersForRecoveryFee.length > 0) {
                    recoveryFeeText =
                        "Además, debido a cuota de recuperación, se le cobrará el 10% del valor de los medicamentos de la orden:\n";
                    ordersForRecoveryFee.map(item => (recoveryFeeText += `- ${item}\n`));
                }

                let medicineText =
                    this.dataMedicines && this.dataMedicines.length > 0 ?
                    this.dataMedicines
                    .map(medicine => {
                        if (medicine.check === true) {
                            return `- ${medicine.count} de ${medicine.description}\n`;
                        } else {
                            return ""
                        }
                    }) : [];
                medicineText = medicineText.join("")
                return (
                    `Su domicilio queda programado para el día ${this.order.deliveryDate ? this.order.deliveryDate : " "
          } ` +
                    `en el horario ${scheduleRange && scheduleRange.range ? scheduleRange.range : " "
          }, ` +
                    `los medicamentos que entregaremos serán:\n\n ${medicineText}\n` +
                    `El valor de la cuota moderadora será máximo ${slidingScaleFeeTotal ? slidingScaleFeeTotal : "0"
          }. ` +
                    `${recoveryFeeText}` +
                    "Podría ser un valor inferior de acuerdo al precio del medicamento. " +
                    `El valor del envío es ${shippingFee}. ` +
                    `Para un total de ${slidingScaleFeeTotal + shippingFee}. ` +
                    "Como el domicilio queda programado, los medicamentos ya no podrán ser entregados en la farmacia. " +
                    "Recuerde esperar al mensajero con documento original o copia del mismo y el valor en efectivo para el pago. " +
                    "¡Que tenga un feliz día!"
                );
            },
            // set(notes) {
            //   this.notes = notes;
            // }
        }
    }
};